import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { EVENT_SOURCES } from '#/utils/constants/general/eventSources';

export function eventSourceFacet(i18n: I18nFn) {
  return {
    id: 'eventSourceFacet',
    name: 'source',
    get title() {
      return i18n('Source');
    },
    type: 'array',
    options: ['IDEALIST', 'NYCPARKS'],
    optionTitles: EVENT_SOURCES,
  } as const satisfies SearchFacetData;
}
